import { createContext } from "react"
import Image1 from '../assets/Explore/Rectangle 446 (1).png'
import Image2 from '../assets/Explore/Rectangle 446 (2).png'
import Image3 from '../assets/Explore/Rectangle 446 (3).png'
import Image4 from '../assets/Explore/Rectangle 446 (4).png'
import Image5 from '../assets/Explore/Rectangle 446 (5).png'
import Image6 from '../assets/Explore/Rectangle 446 (6).png'
import Image7 from '../assets/Explore/Rectangle 446 (7).png'
import Image8 from '../assets/Explore/Rectangle 446 (8).png'
import Image9 from '../assets/Explore/Rectangle 446 (9).png'
import Image10 from '../assets/Explore/Rectangle 446 (10).png'
import Image11 from '../assets/Explore/Rectangle 446 (11).png'
import Image12 from '../assets/Explore/Rectangle 446 (12).png'
import Image13 from '../assets/Explore/Rectangle 446 (13).png'
import Image14 from '../assets/Explore/Rectangle 446 (14).png'

import Svg1 from '../assets/Explore/Frame 2093 (1).svg'
import Svg2 from '../assets/Explore/Frame 2093 (2).svg'
import Svg3 from '../assets/Explore/Frame 2093 (3).svg'
import Svg4 from '../assets/Explore/Frame 2093 (4).svg'
import Svg5 from '../assets/Explore/Frame 2093 (5).svg'
import Svg6 from '../assets/Explore/Frame 2093 (6).svg'
import Svg7 from '../assets/Explore/Frame 2093 (7).svg'
import Svg8 from '../assets/Explore/Frame 2093 (8).svg'
import Svg9 from '../assets/Explore/Frame 2093 (9).svg'
import Svg10 from '../assets/Explore/Frame 2093 (10).svg'
import Svg11 from '../assets/Explore/Frame 2093 (11).svg'
import Svg12 from '../assets/Explore/Frame 2093 (12).svg'
import Svg13 from '../assets/Explore/Frame 2093 (13).svg'
import Svg14 from '../assets/Explore/Frame 2093 (13).svg'

export const ExploreDataProvider = createContext()

const ExploreContextProvider = ({children}) => {
    
    const Explore = [
        {
            image: Image1,
            icon: Svg1,
            heading: "Information Technology (IT) & Software",
            title: "Build the digital future with cutting-edge technology roles",
            skills: ["Web Development", "Mobile App Development", "Cybersecurity", "UI/UX Design", "C++", "AI / ML", "Data Science & Analytics", "Cloud Computing"]
        },

        {
            image: Image2,
            icon: Svg2,
            heading: "Engineering & Manufacturing",
            title: "Build the backbone of industries with innovation.",
            skills: ["Mechanical Engineer", "Manufacturing Engineer", "Sourcing Engineer", "Safety Engineer", "Project Manager", "Creo, Catia, NX, Solidworks", "Offshore Structural Engineer", "CAD Customization Engineer", "CAE / FEA / CFD Analyst", "Lead Stress Engineer"]
        },

        {
            image: Image3,
            icon: Svg3,
            heading: "Electrical & Electronics Engineering",
            title: "Build the backbone of industries with innovation.",
            skills: ["Embedded Testing", "Embedded C, C++ Developer", "Matlab", "System Testing", "Unit Testing", "Analog & Digital", "Sourcing Engineer"]
        },

        {
            image: Image4,
            icon: Svg4,
            heading: "Healthcare & Pharmaceuticals",
            title: "Medical science and improve global healthcare outcomes.",
            skills: ["Medical Billing & Coding", "Hospital Admin", "AI in Healthcare", "Telemedicine Specialist", "Doctor (General Practitioner, Specialist)", "Lab Technician", "Biomedical Engineer", "Clinical Data Analyst", "Biotechnologist", "Nutritionist", "Geneticist", "R&D Scientist (Pharma)"]
        },

        {
            image: Image5,
            icon: Svg5,
            heading: "Education & Training",
            title: "Shape minds, inspire growth, and unlock human potential.",
            skills: ["School Teacher", "College Lecturer", "Corporate Trainer", "Instructional Designer", "E-learning Specialist", "Curriculum Developer", "Academic Researcher", "Career Counselor", "Special Education Teacher", "Online Tutor", "Education Administrator", "Teaching Assistant", "EdTech Product Designer"]
        },

        {
            image: Image6,
            icon: Svg6,
            heading: "Banking, Finance & Insurance",
            title: "Secure wealth, manage risks, and fuel global economies.",
            skills: ["Accountant", "Financial Analyst", "Loan Officer", "Insurance Executive", "Risk Analyst", "Tax Consultant", "Investment Banker", "Credit Analyst", "Mutual Fund Specialist", "Treasury Analyst", "Compliance Officer", "FinTech Product Manager", "Blockchain Analyst", "Quantitative Researcher"]

        },

        {
            image: Image7,
            icon: Svg7,
            heading: "Human Resources & Recruitment",
            title: "Empower people, shape careers, and build strong cultures",
            skills: ["HR Executive", "Payroll Specialist", "HR Generalist", "Talent Acquisition Specialist", "HR Business Partner", "L&D Specialist", "Onboarding Specialist", "Employee Relations Manager", "HR Tech Consultant", "HR Analytics Specialist", "Employer Branding Specialist", "Organizational Development Consultant"]
        },

        {
            image: Image8,
            icon: Svg8,
            heading: "Media, Advertising & Entertainment",
            title: "Bring ideas to life with creativity and storytelling",
            skills: ["Content Writer", "Copywriter", "Graphic Designer", "Photographer", "HR Business Partner", "Videographer", "Animator", "Social Media Content Creator", "Brand Storyteller", "Creative Director", "Advertising Manager", "Entertainment Product Manager", "Creative Strategist", "Art Director"]
        },

        {
            image: Image9,
            icon: Svg9,
            heading: "Retail & E-commerce",
            title: "Redefine shopping experiences online and offline",
            skills: ["Store Manager", "Retail Sales Executive", "POS Technical Admin", "Merchandiser", "Online Store Manager", "Inventory Analyst", "Category Manager", "Employee Relations Manager", "Customer Support Executive", "Warehouse Coordinator", "Product Listing Specialist", "Retail Operations Manager"]
        },

        {
            image: Image10,
            icon: Svg10,
            heading: "Hospitality, Travel & Tourism",
            title: "Create unforgettable journeys and experiences worldwide",
            skills: ["Hotel Front Desk Associate", "Travel Agent", "Food & Beverage Staff", "Housekeeping Supervisor", "Tour Guide", "Cruise Operations Staff", "Restaurant Manager", "Airline Ground Staff", "Luxury Travel Specialist", "Catering Manager", "Resort Operations Manager", "Reservation Executive"]
        },

        {
            image: Image11,
            icon: Svg11,
            heading: "Construction & Real Estate",
            title: "Build spaces, shape skylines, and design better living",
            skills: ["Civil Engineer", "Structural Engineer", "Site Supervisor", "Quantity Surveyor", "Real Estate Agent", "Property Manager", "Land Development Engineer", "Health & Safety Officer (Construction)", "Contracts Manager", "Green Building Consultant", "Smart City Planner", "Interior Designer", "CAD Technician"]
        },

        {
            image: Image12,
            icon: Svg12,
            heading: "Logistics, Transport & Supply Chain",
            title: "Move goods, connect markets, and drive trade.",
            skills: ["Supply Chain Coordinator", "Warehouse Executive", "Logistics Officer", "Export/Import Executive", "Freight Forwarder", "Fleet Manager", "Inventory Planner", "Customs Clearance Specialist", "Shipping Coordinator", "Order Fulfillment Specialist", "Distribution Manager", "Transport Operations Manager"]
        },

        {
            image: Image13,
            icon: Svg13,
            heading: "Automotive & Aerospace",
            title: "Engineer mobility and explore frontiers of travel",
            skills: ["Automotive Engineer", "Vehicle Application Engineer", "Mechanical Design Engineer", "Electrical Design Engineer", "Hil Testing Engineer", "V&V Engineer", "Embedded C/C++ Developer", "Test Engineer (BCM & ECU)", "Aero Engine Component Design Engineer", "Lead Stress Engineer", "Autosar Developer"]
        },

        {
            image: Image14,
            icon: Svg14,
            heading: "Agriculture & Food Technology",
            title: "Feed the world with innovation and sustainability",
            skills: ["Agronomist", "Food Technologist", "Farm Supervisor", "Agricultural Engineer", "Irrigation Engineer", "Food Processing Engineer", "Veterinary Doctor", "Fisheries Specialist", "AgriTech Software Developer", "Supply Chain Specialist (Agri)", "Post-Harvest Technologist", "Agri Product Manager"]
        }

    ]

    const data = { Explore }

    return (
        <ExploreDataProvider.Provider value={data}>
            {children}
        </ExploreDataProvider.Provider>
    )
}

export default ExploreContextProvider